import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.TermsConditionsDetailView.';

  public static readonly provideTermsConditionsName = `${Id.prefix}provideTermsConditionsName`;
  public static readonly termsConditionsInfo = `${Id.prefix}termsConditionsInfo`;
  public static readonly termsConditions = `${Id.prefix}termsConditions`;
  public static readonly terms = `${Id.prefix}terms`;
  public static readonly isDefault = `${Id.prefix}isDefault`;
}

export class LangTermsConditionsDetailView {
  private constructor() {}

  public static provideTermsConditionsName(): string {
    return interpolate(Id.provideTermsConditionsName);
  }
  public static termsConditionsInfo(): string {
    return interpolate(Id.termsConditionsInfo);
  }
  public static termsConditions(): string {
    return interpolate(Id.termsConditions);
  }
  public static terms(): string {
    return interpolate(Id.terms);
  }
  public static isDefault(): string {
    return interpolate(Id.isDefault);
  }
}

export class TermsConditionsDetailViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.provideTermsConditionsName, 'Please provide a name', 'Validation for terms and conditions name');
    register.add(Id.termsConditionsInfo, "{{ glossary 'terms-conditions' }} Info", 'Caption for terms conditions info');
    register.add(Id.termsConditions, 'Name', 'Label for terms conditions name');
    register.add(Id.terms, "{{glossary 'terms-conditions'}}", 'Label for terms and conditions text area');
    register.add(Id.isDefault, 'Default', 'Label for is default checkbox');
  }
}
